(() => {
  const initAccountGuide = (section) => {
    if (section.dataset.accountGuideReady === 'true') return;

    const dialog = section.querySelector('[data-account-media-dialog]');
    const dialogImage = dialog?.querySelector('[data-account-dialog-image]');
    const closeButton = dialog?.querySelector('[data-account-media-close]');
    let lastTrigger = null;
    let activeHistoryEntry = false;

    const isDialogOpen = () => dialog && !dialog.hidden;

    const cleanUpDialog = () => {
      if (dialogImage) {
        dialogImage.removeAttribute('src');
        dialogImage.hidden = true;
      }
      document.documentElement.classList.remove('venja-account-guide-modal-open');
      lastTrigger?.focus();
    };

    const openTaskFromHash = () => {
      if (!window.location.hash) return;

      const target = document.getElementById(window.location.hash.slice(1));
      if (!target || !section.contains(target) || !target.matches('[data-account-task]')) return;

      target.open = true;
      window.requestAnimationFrame(() => {
        target.querySelector('summary')?.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    };

    const closeDialog = ({ restoreHistory = true } = {}) => {
      if (!isDialogOpen()) return;

      dialog.hidden = true;
      cleanUpDialog();
      if (restoreHistory && activeHistoryEntry) {
        activeHistoryEntry = false;
        window.history.back();
      }
    };

    section.querySelectorAll('.venja-account-guide__chooser-link').forEach((link) => {
      link.addEventListener('click', () => {
        window.requestAnimationFrame(openTaskFromHash);
      });
    });

    section.querySelectorAll('[data-account-media-open]').forEach((button) => {
      button.addEventListener('click', () => {
        if (!dialog || !dialogImage) return;

        lastTrigger = button;
        dialogImage.src = button.dataset.mediaSrc || '';
        dialogImage.alt = button.dataset.mediaAlt || '';
        dialogImage.width = Number(button.dataset.mediaWidth) || 1200;
        dialogImage.height = Number(button.dataset.mediaHeight) || 800;
        dialogImage.hidden = false;

        const modalHash = `#${button.id}`;
        window.history.pushState({ venjaAccountGuide: dialog.id }, '', modalHash);
        activeHistoryEntry = true;
        dialog.hidden = false;
        document.documentElement.classList.add('venja-account-guide-modal-open');
        closeButton?.focus();
      });
    });

    closeButton?.addEventListener('click', () => closeDialog());

    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) closeDialog();
    });

    document.addEventListener('keydown', (event) => {
      if (!isDialogOpen()) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeDialog();
        return;
      }

      if (event.key === 'Tab') {
        const focusable = [...dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')]
          .filter((element) => !element.hidden && !element.hasAttribute('disabled'));
        if (focusable.length === 0) return;

        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    window.addEventListener('popstate', () => {
      activeHistoryEntry = false;
      closeDialog({ restoreHistory: false });
      openTaskFromHash();
    });

    window.addEventListener('hashchange', openTaskFromHash);
    section.dataset.accountGuideReady = 'true';
    openTaskFromHash();
  };

  const initAll = (root = document) => {
    root.querySelectorAll('[data-account-guide]').forEach(initAccountGuide);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
